import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  FcConversion, FcConversionPreview, FcConversionRequest, FcPosition,
} from '../interfaces/fcBank.interface';

const E = ENDPOINTS.FC_CONVERSION;

export const FcConversionService = {
  list: async (institutionId: string, status?: string): Promise<FcConversion[]> =>
    (await axios.get(E.LIST(institutionId), { params: status ? { status } : {} })).data,
  positions: async (institutionId: string, asOf?: string): Promise<FcPosition[]> =>
    (await axios.get(E.POSITIONS(institutionId), { params: asOf ? { asOf } : {} })).data,
  get: async (id: string): Promise<FcConversion> => (await axios.get(E.ONE(id))).data,
  preview: async (body: FcConversionRequest): Promise<FcConversionPreview> => (await axios.post(E.PREVIEW, body)).data,
  create: async (body: FcConversionRequest): Promise<FcConversion> => (await axios.post(E.BASE, body)).data,
  /** States the account's true FC balance on a date (lines up to it are then ignored by the FC reads). */
  setAnchor: async (institutionId: string, bankAccountId: string, date: string, fcBalance: number): Promise<FcPosition> =>
    (await axios.put(E.ANCHOR(institutionId, bankAccountId), { date, fcBalance })).data,
  clearAnchor: async (institutionId: string, bankAccountId: string): Promise<FcPosition> =>
    (await axios.delete(E.ANCHOR(institutionId, bankAccountId))).data,
  reverse: async (id: string, reason?: string): Promise<FcConversion> =>
    (await axios.post(E.REVERSE(id), { reason })).data,
};
